export interface Lock {
  id: string;
  name: string;
  serialNumber: string;
}

export const KEY_DURATION_MS = 24 * 60 * 60 * 1000;

export interface DigitalKey {
  value: string;
  fetchedAt: number; // client-side Date.now() when claim response was received
  expiresAt: number; // epoch ms derived from guest_key_expires_at
}

export type KeyStatus = 'none' | 'fetching' | 'valid' | 'expired';
